import { Icon as ChakraIcon, HTMLChakraProps, ChakraProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import * as siteLogos from './svgs';

import { forwardRef } from 'system';

export const siteLogoList = Object.keys(siteLogos);

const propTypes = {
  type: PropTypes.string.isRequired,
  boxSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  role: PropTypes.string,
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  boxSize: '1em',
  role: undefined,
  hideBackground: false,
  isRound: false
};

type ExternalComponentProps = HTMLChakraProps<'svg'>;
type InternalChakraIconProps = Omit<React.SVGAttributes<SVGElement>, keyof ChakraProps>;

export type SiteLogoProps = ExternalComponentProps & { type: string; isRound?: boolean; hideBackground?: boolean };

const SiteLogo = forwardRef<SiteLogoProps, 'svg'>((props: SiteLogoProps & typeof defaultProps, ref) => {
  const { type, hideBackground, isRound, ...rest } = props;

  const Component = siteLogos[type];

  const mergedProps = { ...rest } as InternalChakraIconProps;

  useEffect(() => {
    if (!siteLogos[type]) {
      // eslint-disable-next-line no-console
      console.error(`Invalid type passed to <SiteLogo />. Unable to find a site logo with the name "${type}"`);
    }
  }, [type]);

  return (
    <ChakraIcon {...mergedProps} ref={ref} viewBox="0 0 24 24">
      {siteLogos[type] ? (
        <Component data-testid="site-logo-svg" hideBackground={hideBackground} isRound={isRound} />
      ) : (
        <></>
      )}
    </ChakraIcon>
  );
});

SiteLogo.displayName = 'SiteLogo';
SiteLogo.propTypes = propTypes;
SiteLogo.defaultProps = defaultProps;

export default SiteLogo;
